<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Create a new user</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!userCreated" class="container">
            <div class="form-group">
                <label for="Email">Email:</label>
                <input v-model="email" type="email" class="form-control" placeholder="Work email of an user">
                <ValidationError context="Email" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="FirstName">First name:</label>
                <input v-model="firstName" type="text" class="form-control" placeholder="First name of an user">
                <ValidationError context="FirstName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="LastName">Last name:</label>
                <input v-model="lastName" type="text" class="form-control" placeholder="Last name of an user">
                <ValidationError context="LastName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group form-check">
                <input v-model="setInitialPassword" type="checkbox" class="form-check-input" id="setInitialPassword">
                <label class="form-check-label" for="setInitialPassword">Set initial password manually</label>
            </div>

            <div v-show="setInitialPassword">
                <div class="form-group">
                    <label for="Password">Initial password:</label>
                    <input v-model="password" type="password" class="form-control">
                    <ValidationError context="Password" :errors="validationErrors"></ValidationError>
                </div>

                <div class="form-group" v-show="password">
                    <label for="PasswordConfirmation">Initial password confirmation:</label>
                    <input v-model="passwordConfirmation" type="password" class="form-control" :class="{ 'is-invalid': passwordConfirmationInvalid }">
                    <div class="invalid-feedback">Initial password confirmation doesn't match</div>
                </div>
            </div>

            <button v-show="statusInitial || statusInvalid" @click="handleCreateUserCommandV1" type="button" class="btn btn-primary btn-lg" :disabled="passwordConfirmationInvalid">Create</button>
            <button v-show="statusInvoking" type="button" class="btn btn-primary btn-lg" disabled>Creating...</button>
        </div>

        <div v-else class="container">
            <h4 class="fg-color-blue">User was created and initial system generated password was sent on {{email}}</h4>
            <br />

            <a :href="`/#/admin/organizations/users/manage/type/${email}`" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                <i class="fa fa-external-link" aria-hidden="true"></i>
                <span>Manage user roles</span>
            </a>

            <h4 class="fg-color-blue" style="margin: 20px 0;">or</h4>

            <a :href="`/#/admin/organizations/users/manage/workspaces/${email}`" class="btn btn-secondary text-white" style="padding: 0.7em 2em;">
                <i class="fa fa-external-link" aria-hidden="true"></i>
                <span>Manage user workspaces</span>
            </a>

            <h4 class="fg-color-blue" style="margin: 20px 0;">or</h4>

            <button @click="handleFinish" class="btn btn-secondary text-white" style="padding: 0.7em 2em;">
                <i class="fa fa-user-plus" aria-hidden="true"></i>
                <span>Add another user</span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import Queries from "@Organizations/Users/Domain/queries-vue-component";
    import Commands from "@Organizations/Users/Domain/commands-vue-component";
    import "@common/AdminNavigationV2.vue";
    import "@common/Components/ValidationError.vue";

    @Component
    export default class CreateUserPage extends mixins(PageBase, PageStatus, Queries, Commands) {
        email = ''
        firstName = ''
        lastName = ''
        password = ''
        passwordConfirmation = ''
        setInitialPassword = false
        userCreated = false

        mounted() {
            this.runCurrentUserQueryV1(false, false, true)
            this.setTitle('Create a new user');
        }

        get passwordConfirmationInvalid(): boolean {
            if (this.setInitialPassword) {
                return this.passwordConfirmation && (this.passwordConfirmation != this.password)
            }
            return false
        }

        handleCreateUserCommandV1() {
            this.$clearValidationErrors();
            this.setStatusInvoking();
            this.invokeCreateUserCommandV1('0', this.tid, this.email, this.firstName, this.lastName, false, false, true, this.setInitialPassword, this.password);
        }

        succeedCreateUserCommandV1() {
            this.setStatusSucceed();
            this.userCreated = true;
        }

        invalidCreateUserCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.setStatusInvalid();
        }

        failedCreateUserCommandV1(status) {
            this.setStatusFailed();
        }

        handleFinish() {
            this.email = '';
            this.firstName = '';
            this.lastName = '';
            this.userCreated = false;
            this.setStatusInitial();
        }
    }
</script>
